import React, { useState } from 'react';
import './MapSection.css';

const MapSection = () => {
  const [hoveredLocation, setHoveredLocation] = useState(null);

  const nearbyLocations = [
    {
      id: 1,
      name: "Jim Corbett National Park",
      coordinates: { lat: 29.5328, lng: 78.9564 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Famous tiger reserve and wildlife sanctuary"
    },
    {
      id: 2,
      name: "Nainital",
      coordinates: { lat: 29.3803, lng: 79.4636 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Beautiful hill station with Naini Lake"
    },
    {
      id: 3,
      name: "Ranikhet",
      coordinates: { lat: 29.6406, lng: 79.4322 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Scenic hill station with panoramic views"
    },
    {
      id: 4,
      name: "Almora",
      coordinates: { lat: 29.5904, lng: 79.6507 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Cultural hub with ancient temples"
    },
    {
      id: 5,
      name: "Mukteshwar",
      coordinates: { lat: 29.4722, lng: 79.6514 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Peaceful destination with apple orchards"
    },
    {
      id: 6,
      name: "Kausani",
      coordinates: { lat: 29.8444, lng: 79.6031 },
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
      description: "Stunning views of Himalayan peaks"
    }
  ];

  const amodaSariLocation = {
    lat: 29.5904,
    lng: 79.6507,
    name: "Amoda Sari"
  };

  return (
    <section className="map-section">
      <div className="container">
        <div className="map-header">
          <p className="map-subtitle">IN THE HEART OF THE HIMALAYAS</p>
        </div>
        
        <div className="map-container">
          <div className="map-wrapper">
            {/* Google Map Embed */}
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3468.501050346515!2d79.71973757532783!3d29.61818747514098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a0b70520cbeeff%3A0x5ab673a068ce580a!2sAmoda%20Sari!5e0!3m2!1sen!2sin!4v1761818101890!5m2!1sen!2sin&maptype=satellite"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Amoda Sari Google Map"
            ></iframe>
            
            {/* Custom markers for nearby locations */}
            <div className="map-markers">
              {nearbyLocations.map((location) => (
                <div
                  key={location.id}
                  className="map-marker"
                  style={{
                    left: `${((location.coordinates.lng - 79.0) / 1.0) * 100}%`,
                    top: `${((29.8 - location.coordinates.lat) / 0.5) * 100}%`
                  }}
                  onMouseEnter={() => setHoveredLocation(location)}
                  onMouseLeave={() => setHoveredLocation(null)}
                >
                  <div className="marker-pin"></div>
                  <div className="marker-label">{location.name}</div>
                </div>
              ))}
              
              {/* Amoda Sari marker */}
              <div
                className="map-marker amoda-marker"
                style={{
                  left: `${((amodaSariLocation.lng - 79.0) / 1.0) * 100}%`,
                  top: `${((29.8 - amodaSariLocation.lat) / 0.5) * 100}%`
                }}
                onMouseEnter={() => setHoveredLocation({
                  ...amodaSariLocation,
                  image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=300&fit=crop",
                  description: "Luxury A-frame accommodation in the heart of Himalayas"
                })}
                onMouseLeave={() => setHoveredLocation(null)}
              >
                <div className="marker-pin amoda-pin"></div>
                <div className="marker-label amoda-label">{amodaSariLocation.name}</div>
              </div>
            </div>
          </div>
          
          {/* Hover info card */}
          {hoveredLocation && (
            <div className="location-info-card">
              <div className="info-image">
                <img src={hoveredLocation.image} alt={hoveredLocation.name} />
              </div>
              <div className="info-content">
                <h3 className="info-title">{hoveredLocation.name}</h3>
                <p className="info-description">{hoveredLocation.description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default MapSection;